import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllPageGroups(oauthTokenHeader: string, website_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/page_groups/${website_shared_uid}/`,
    oauthTokenHeader
  );
}

function getSinglePageGroup(
  oauthTokenHeader: string,
  website_shared_uid: any,
  page_shared_uid: any
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/page_groups/${website_shared_uid}/${page_shared_uid}/`,
    oauthTokenHeader
  );
}

function getPopupOffers(oauthTokenHeader: string, website_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/widgets/${website_shared_uid}/`,
    oauthTokenHeader
  );
}

function getAllThemes(oauthTokenHeader: string, website_shared_uid: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/design/themes/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
}

function getWebsiteAttributeDetails(
  oauthTokenHeader: string,
  website_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/attributes/${website_shared_uid}/`,
    oauthTokenHeader
  );
}

function uploadImage(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/images/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function createPageGroup(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/page_groups/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function editPageGroup(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any,
  page_group_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/page_groups/${website_shared_uid}/${page_group_uid}/`,
    data,
    oauthTokenHeader
  );
}

function pageGroupLinks(
  oauthTokenHeader: string,
  data: any,
  page_group_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/page_groups/links/${page_group_uid}/`,
    data,
    oauthTokenHeader
  );
}

function toggleStatusPageGroup(oauthTokenHeader: string,data: any,website_shared_uid: any,page_group_uid: any) {
    return fetchWrapper.put(`${apiUrl}/asset_management/page_groups/${website_shared_uid}/${page_group_uid}/`,data,oauthTokenHeader);
}

function getAllPages(oauthTokenHeader: string,website_shared_uid: any) {
    return fetchWrapper.get(`${apiUrl}/asset_management/pages/${website_shared_uid}/`,oauthTokenHeader);
}

function getNextPages(nextUrl: any, oauthTokenHeader: string) {
  return fetchWrapper.get(`${nextUrl}`, oauthTokenHeader);
}

function assignPageGroupToPages(data: any, website_shared_uid:any, page_shared_uid:any, oauthTokenHeader:any) {
    return fetchWrapper.put(`${apiUrl}/asset_management/pages/${website_shared_uid}/${page_shared_uid}/`, data, oauthTokenHeader);
}

export const pageGroupServices = {
    getAllPageGroups,getSinglePageGroup, getPopupOffers, getAllThemes, getWebsiteAttributeDetails,
    uploadImage, createPageGroup, editPageGroup, toggleStatusPageGroup,getAllPages, getNextPages, pageGroupLinks, assignPageGroupToPages
};
